import React from 'react';

import { StyledPin } from './styles';

export const GoogleMapPin = ({ lat, lng }: any): JSX.Element => {
  return <StyledPin lat={lat} lng={lng} />;
};
